import { crewElasticData } from '../actions/dashboard';
import { isToday } from '../helpers/common';
import {
    LIVE_MESSAGE, DASHBOARD_GET_CREW_GRAPH, DASHBOARD_GET_CREW_ELASTIC_DATA, DASHBOARD_GET_SOURCE_EG_ELASTIC_DATA, DASHBOARD_GET_WORKED_ACRES
} from '../constants/action-types';
import { getAnalyzeTopics } from '../actions/analyze';

const elasticDataReceivedFromLive = (store, action) => {
    const state = store.getState();
    if (!action.message) return action;

    const { range } = state.analyze.searchParams;
    action = { ...action, range: range };

    if (!isToday(range)) return action;
    const live = action.message;

    //Crew view
    if (state.dashboard.crew.selectedCrewIds.indexOf(live.deviceId) >= 0) {
        const topics = getAnalyzeTopics({ crewId: live.deviceId, view: "crew" });
        const findTopics = topics.filter(e => e.subscribeDeviceId === live.deviceId && (e.topic === live.name || e.action === live.name));
        if (findTopics.length === 0) return action;
        const item = findTopics[0];
        const data = live.initial ? live.message.data : live.message;
        const elastic = { isLive: true, data };
        store.dispatch(crewElasticData(live.deviceId, item.keyname, elastic));
    }

    return action;
}

const dashboardMiddleware = store => {
    return next => action => {
        switch (action.type) {
            case DASHBOARD_GET_CREW_GRAPH:
                action = {
                    ...action,
                    range: store.getState().analyze.searchParams.range,
                    timezone: store.getState().farm.currentFarm.timezone_identifier
                };
                break;
            case DASHBOARD_GET_CREW_ELASTIC_DATA:
                action = {
                    ...action,
                    range: store.getState().analyze.searchParams.range,
                    timezone: store.getState().farm.currentFarm.timezone_identifier
                };
                break;
            case DASHBOARD_GET_SOURCE_EG_ELASTIC_DATA:
                action = { ...action, range: store.getState().analyze.searchParams.range };
                break;
            case DASHBOARD_GET_WORKED_ACRES:
                action = { ...action, range: store.getState().analyze.searchParams.range };
                break;
            case LIVE_MESSAGE:
                action = elasticDataReceivedFromLive(store, action);
                break;
            default:
                break;
        }

        return next(action);
    };
};

export default dashboardMiddleware;